<template>
  <div
    class="vacancy-benefits-collapse"
    :class="selector"
  >
    <div
      @click="openCollapse = !openCollapse"
      class="vacancy-benefits-collapse__head">
      <div class="vacancy-benefits-collapse__icon-block">
        <BaseSvg
          class="vacancy-benefits-collapse__icon"
          :name="iconName"/>
      </div>
      <span class="vacancy-benefits-collapse__name">
        {{ title }}
      </span>

      <div class="vacancy-benefits-collapse__check">
        <BaseSvg
          class="vacancy-benefits-collapse__icon-check"
          name="ico-check"/>
      </div>
    </div>
    <collapse-transition>
      <div
        v-if="openCollapse"
        ref="sections"
        class="vacancy-benefits-collapse__body">
        <slot></slot>
      </div>
    </collapse-transition>

  </div>
</template>

<script>
  import {CollapseTransition} from 'vue2-transitions'

  export default {
    name: "BenefitsCollapse",
    components: {
      CollapseTransition
    },
    props: {
      iconName: {
        type: String,
        required: false,
      },
      title: {
        type: String,
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      filled: {
        type: Boolean,
        default: false
      }
    },
    data: (v) => ({
      openCollapse: v.isOpen,
    }),
    computed: {
      selector() {
        return {
          '_filled': this.filled,
          '_active': this.openCollapse,
        }
      }
    },
    methods: {
      open() {
        this.openCollapse = true;
      },
    },
  }
</script>

<style scoped>

</style>
